import { AlertModal } from "../../components/Modals/AlertModal/AlertModal";
import { Edit, Trash, More } from "@rsuite/icons";
import React, { useState } from "react";
import { Popover, Dropdown, IconButton, Whisper } from "rsuite";
import ViewCommercialSchedule from "./ViewCommercialSchedule";
import { useDispatch } from "react-redux";
import { setActionData } from "../../../redux/userActionData";
import { useNavigate } from "react-router-dom";
import { statusArr } from "../../../core/config/AppConstants";
import { useTranslation } from "react-i18next";
import { encryptUrl } from "../../../navigation/useDecryptParams";
import { ContentRoutes } from "../../../navigation/NavConstant";

const CommercialScheduleSingleAction = ({
  commercialScheduleData,
  onDeleteCommercialSchedule,
  onPublishCommercialSchedule,
  permission,
  ...props
}: {
  commercialScheduleData: any;
  onDeleteCommercialSchedule: Function;
  onPublishCommercialSchedule: Function;
  permission: any;
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [openModalByName, setOpenModalByName] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openPublishModal, setOpenPublishModal] = useState(false);
  const [publishMessage, setPublishMessage] = useState("");
  const ecryptedCommercialScheduleId = encryptUrl(
    `${commercialScheduleData.id}`
  );

  const commercialScheduleUpdateLink =
    ContentRoutes.UPDATE_COMMERCIAL_SCHEDULE.replace(
      ":id",
      ecryptedCommercialScheduleId.toString()
    );
  const navigate = useNavigate();
  const publishText =
    commercialScheduleData.status == statusArr.active
      ? t("UNPUBLISH").toLowerCase()
      : t("PUBLISH").toLowerCase();
  const pMessage = t("CONFIRM_ACTION", {
    action:
      commercialScheduleData.status == statusArr.active
        ? t("UNPUBLISH").toLowerCase()
        : t("PUBLISH").toLowerCase(),
    entity: t("COMMERCIAL_SCHEDULE").toLowerCase(),
  });

  const renderMenu = (
    {
      onClose,
      left,
      top,
      className,
    }: { onClose: any; left: any; top: any; className: any },
    ref:
      | ((instance: HTMLDivElement | null) => void)
      | React.RefObject<HTMLDivElement>
      | null
      | undefined
  ) => {
    const handleSelect = (eventKey: any) => {
      if (eventKey == "view-commercial-schedule") {
        setOpenModalByName(eventKey);
        dispatch(setActionData(commercialScheduleData));
        onClose && onClose();
      } else if (eventKey == "edit-commercial-schedule") {
        handleEditAction();
      } else if (eventKey == "publish-commercial-schedule") {
        setOpenPublishModal(true);
        setPublishMessage(pMessage);
      } else if (eventKey == "delete-commercial-schedule") {
        setOpenDeleteModal(true);
      }
    };
    return (
      <Popover ref={ref} className={className} style={{ left, top }} full>
        <Dropdown.Menu onSelect={handleSelect}>
          <Dropdown.Item eventKey={"view-commercial-schedule"}>
            {t("VIEW")}
          </Dropdown.Item>
          {permission.update && (
            <Dropdown.Item eventKey={"edit-commercial-schedule"}>
              {t("EDIT")}
            </Dropdown.Item>
          )}
          {permission.publish && (
            <Dropdown.Item eventKey={"publish-commercial-schedule"}>
              {publishText}
            </Dropdown.Item>
          )}
          {permission.delete && (
            <Dropdown.Item eventKey={"delete-commercial-schedule"}>
              {t("DELETE")}
            </Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Popover>
    );
  };

  function handleEditAction() {
    navigate(`${commercialScheduleUpdateLink}`);
  }
  return (
    <div>
      <Whisper
        placement="topEnd"
        trigger="click"
        speaker={renderMenu}
        preventOverflow={true}
      >
        <IconButton appearance="subtle" icon={<More />} />
      </Whisper>
      {openModalByName === "view-commercial-schedule" && (
        <ViewCommercialSchedule
          status={openModalByName === "view-commercial-schedule" ? true : false}
          toggle={setOpenModalByName}
        />
      )}
      <AlertModal
        open={openDeleteModal}
        handleClose={(e: any) => {
          if (e == true) {
            onDeleteCommercialSchedule(commercialScheduleData);
            setOpenDeleteModal(false);
          } else {
            setOpenDeleteModal(false);
          }
        }}
        displayText={t("CONFIRM_ACTION", {
          action: t("DELETE").toLowerCase(),
          entity: t("COMMERCIAL_SCHEDULE").toLowerCase(),
        })}
        modalTitle={t("CONFIRM_ACTION_TITLE", {
          action: t("DELETE").toLowerCase(),
        })}
      />
      <AlertModal
        open={openPublishModal}
        handleClose={(e: any) => {
          if (e == true) {
            onPublishCommercialSchedule(commercialScheduleData);
            setOpenPublishModal(false);
          } else {
            setOpenPublishModal(false);
          }
        }}
        displayText={publishMessage}
      />
    </div>
  );
};

export default CommercialScheduleSingleAction;
